import { useEffect } from "react"

type MountEffect = () => void | (() => void)

export function useMountEffect(effect: MountEffect) {
  useEffect(effect, [])
}
